// general 'toast' alert system.
// This is the source of truth for util/Alert.vue
// use this after async actions go right/wrong

import { UPDATE_ALERT, SET_TOASTER } from './constants';

const isString = (payLoad) => typeof payLoad === 'string' || payLoad instanceof String;

const addPayloadToAlert = (payLoad, alertParams, defaultMessage) => {
  if (!payLoad) {
    return {
      ...alertParams,
      message: defaultMessage,
    };
  }
  if (isString(payLoad)) {
    return {
      ...alertParams,
      message: payLoad,
    };
  }
  const { message } = payLoad;
  const alertObject = {
    ...alertParams,
    message,
  };

  return alertObject;
};

const defaultState = {
  showAlert: false,
  alertDuration: 0,
  alertVariant: '',
  alertMessage: '',
  alertIcon: '',
  toaster: null,
};

export const mutations = {
  UPDATE_ALERT(state, { shouldShow, variant, message, duration, icon }) {
    state.showAlert = shouldShow;
    state.alertVariant = variant;
    state.alertMessage = message;
    state.alertDuration = duration;
    state.alertIcon = icon;
  },
  SET_TOASTER(state, toaster) {
    state.toaster = toaster;
  },
};

export const actions = {
  // prefer successAlert and failureAlert
  // unless you need to seriously customize the alert
  showAlert(
    { commit },
    {
      variant = 'default',
      duration = 5000,
      message,
      icon = '',
      btnText = null,
      btnCallback = null,
    },
  ) {
    commit(UPDATE_ALERT, {
      shouldShow: true,
      variant,
      duration,
      message,
      icon,
      btnText,
      btnCallback,
    });
  },
  resetAlert({ commit }) {
    commit(UPDATE_ALERT, {
      shouldShow: false,
      variant: '',
      duration: '',
      message: '',
      icon: '',
    });
  },
  successAlert({ dispatch }, payLoad) {
    dispatch(
      'showAlert',
      addPayloadToAlert(
        payLoad,
        {
          variant: 'success',
          duration: 5000,
          icon: 'check-circle',
          iconClass: 'text-success',
        },
        'Success',
      ),
    );
  },

  failureAlert({ dispatch }, payLoad) {
    dispatch(
      'showAlert',
      addPayloadToAlert(
        payLoad,
        {
          variant: 'danger',
          duration: 10000,
          icon: 'times-circle',
          iconClass: 'text-danger',
        },
        'Something went wrong. If this error persists, contact support.',
      ),
    );
  },

  warnAlert({ dispatch }, payLoad) {
    dispatch(
      'showAlert',
      addPayloadToAlert(
        payLoad,
        {
          variant: 'warning',
          duration: 10000,
          icon: 'exclamation-circle',
          iconClass: 'text-warning',
        },
        'Something went wrong. If this error persists, contact support.',
      ),
    );
  },

  setToaster({ commit }, toaster) {
    commit(SET_TOASTER, toaster);
  },
};

export default {
  namespaced: true,
  actions,
  mutations,
  state: defaultState,
};
